import React, { useMemo } from 'react';
import { Table, TableBody, TableHead, TableRow } from '@mui/material';
import {
    StyledTableCell,
    TableCellHeaderContent,
    TableContainer,
    StyledTable,
} from '../../../../shared/components/CustomTable/Styled';
import { FilesTableColumns } from '../../../../configs/files';
import { FileRow } from '../FileTable';
import { File } from '../../../../data/entities';

interface PlainFileTableProps {
    itemList: File[];
    extraRowProps: any;
}

const PlainFileTable = ({ itemList, extraRowProps }: PlainFileTableProps) => {
    // Sort files by date (newest first)
    const sortedItems = useMemo(() => {
        return [...itemList].sort((a, b) => {
            const dateA = new Date(a.created_at).getTime();
            const dateB = new Date(b.created_at).getTime();
            return dateB - dateA; // Newest first
        });
    }, [itemList]);

    return (
        <TableContainer>
            <StyledTable>
                <TableHead>
                    <TableRow>
                        {FilesTableColumns.map((column, index) => (
                            <StyledTableCell key={index}>
                                <TableCellHeaderContent>
                                    {column.text}
                                    {column.icon}
                                </TableCellHeaderContent>
                            </StyledTableCell>
                        ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {sortedItems.map((file) => (
                        <FileRow
                            key={file.id}
                            item={file}
                            extraRowProps={extraRowProps}
                        />
                    ))}
                </TableBody>
            </StyledTable>
        </TableContainer>
    );
};

export default PlainFileTable;

